import React, { Dispatch, SetStateAction, useContext } from 'react';

import Button from '@amzn/meridian/button';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import Toggle from '@amzn/meridian/toggle';

import { useHistory } from 'react-router';
import { ROUTES } from 'src/constants/routes';
import { AppContext } from 'src/contexts/appContext';

export const GeneralSettings: React.FC = (props) => {
    const {
        analyticsFeatureEnabled,
        setAnalyticsFeatureEnabled,
        royaltyManagerFeatureEnabled,
        setRoyaltyManagerFeatureEnabled,
        showDealsRepo,
        setShowDealsRepo
    } = useContext(AppContext);

    return (
        <Column>
            <Text type={'h400'}>General Settings</Text>
            {/* <LinkingToggle
                name={'Analytics'}
                value={analyticsFeatureEnabled}
                setValue={setAnalyticsFeatureEnabled}
                href={ROUTES.ANALYTICS.INDEX}
            /> */}
            <LinkingToggle
                name={'Royalty Manager'}
                value={royaltyManagerFeatureEnabled}
                setValue={setRoyaltyManagerFeatureEnabled}
                href={ROUTES.ROYALTY_MANAGER.INDEX}
            />
            <LinkingToggle
                name={'Agreements'}
                value={showDealsRepo}
                setValue={setShowDealsRepo}
                href={ROUTES.AGREEMENTS.INDEX}
            />
        </Column>
    );
};

interface ILinkingToggle {
    name: string;
    value: boolean;
    setValue: Dispatch<SetStateAction<boolean>>;
    href: string;
}

const LinkingToggle: React.FC<ILinkingToggle> = (props) => {
    const { name, value, setValue, href } = props;
    const history = useHistory();

    return (
        <Row>
            <Toggle checked={value} onChange={setValue}>
                {`Enable ${name} Features`}
            </Toggle>
            {value && (
                <Button type={'tertiary'} size={'small'} onClick={() => history.push(href)}>
                    {`Go to ${name}`}
                </Button>
            )}
        </Row>
    );
};
